import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { URLS } from '@wix/da-url';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import EmptyStateBase from '../EmptyState';
import BuyCoreButton from '@wix/da-shared-react/pkg/Button/BuyCoreButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { PapiUser } from '@wix/da-papi-types';
import EmptyState from '../../../../EmptyState';
import { ShopItemType } from '../../../../../../types/shop';
import CoreExclusive from '../CoreExclusive';

import s from './PremiumContentEmptyState.scss';

export interface Props {
  view: 'wide' | 'large' | 'small';
  user: PapiUser;
  isOwner: boolean;
  hasCoreMembership?: boolean;
}

export const PremiumContentEmptyState: React.FC<Props> = ({
  view,
  isOwner,
  hasCoreMembership,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  if (isOwner) {
    if (hasCoreMembership) {
      return (
        <EmptyState
          className={classnames(s['root'], s[view])}
          title={t('pages.shop.emptyState.core.premiumContent.title')}
          titleClassName={s['title']}
          subtitle={
            isMobile
              ? t('pages.shop.emptyState.core.premiumContent.subtitle.mobile')
              : t('pages.shop.emptyState.core.premiumContent.subtitle')
          }
          subtitleClassName={s['subtitle']}
          illustration={<CoreExclusive />}
          illustrationClassName={s['exclusive']}
          withButton={!isMobile}
          buttonLabel={t('common.submit')}
          onButtonClick={() => {
            if (window) {
              window.location.replace(URLS.SUBMIT);
            }
          }}
          view={'small'}
          biData={BiData<DefaultBiEvent>({
            evid: 2,
            click_info: 'create_premium_download',
            sectionname: 'premium_download',
          })}
        />
      );
    } else {
      return (
        <EmptyState
          className={classnames(s['root'], s[view])}
          title={t('pages.shop.emptyState.nonCore.premiumContent.title')}
          titleClassName={s['title']}
          subtitle={t(
            isMobile
              ? 'pages.shop.emptyState.nonCore.premiumContent.subtitle.mobile'
              : 'pages.shop.emptyState.nonCore.premiumContent.subtitle'
          )}
          subtitleClassName={s['subtitle']}
          illustration={<CoreExclusive />}
          illustrationClassName={s['exclusive']}
          customButton={
            isMobile ? undefined : (
              <BuyCoreButton
                size="large"
                biData={{
                  referral_info: ReferralType.SHOP_PREMIUM_DOWNLOADS,
                }}
              >
                {t('widgets.tierContent.empty.cta.getCore')}
              </BuyCoreButton>
            )
          }
          view={'small'}
        />
      );
    }
  }

  return (
    <EmptyStateBase shopItemType={ShopItemType.PREMIUM_CONTENT} view="wide" />
  );
};

PremiumContentEmptyState.displayName = 'PremiumContentEmptyState';

export default PremiumContentEmptyState;
